"use client";

export const getInvoiceContactIdForFrontend = (userData) => {
  return String(userData?.sevDeskId || "").trim();
};
